import { SERVICE } from '@web-platform/shared-universal-constants/src/adverts';

import type { RadarCreative } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarCreativeTypes';
import type { Slot } from '@web-platform/shared-universal-types/src/network/endpoints/strevda';
import type { ConductorCreative } from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';
import type { ID } from '@web-platform/shared-universal-types-utils/src/utils';

export const generateAdvertIdFromCreative = (creative: ConductorCreative | RadarCreative): ID => {
  const analyticsProperties =
    `analytics_properties` in creative
      ? creative.analytics_properties
      : creative.analyticsProperties;

  return `${analyticsProperties.service}-${creative.fields.appIndex}`;
};

export const generateAdvertIdFromRadarCreative = (creative: RadarCreative): ID =>
  `${creative.analyticsProperties.service}-${creative.fields.appIndex}`;

export const generateAdvertIdFromStrevdaSlot = (slot: Slot): ID => {
  const { position } = slot;
  return `${SERVICE.DFP}-${position}`;
};
